export default "/images/marker.png?f60f17c52fed837fe906b4bb728fc124";